export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-dashboard',
      },
    },
    {
      name: 'member-reports',
      displayName: 'menu.member-reports',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-forms',
      },
      disabled: true,
      children: [
        {
          name: 'MEMBSTMNT',
          displayName: 'menu.member-statement',
        },
        {
          name: 'DEPSTMNT',
          displayName: 'menu.deposit-statement',
        },
        {
          name: 'GUAREP',
          displayName: 'menu.guaranteed-loans',
        },
        {
          name: 'GUALNS',
          displayName: 'menu.guarantor-reports',
        },
        // {
        //   name: 'FOSASTMNT',
        //   displayName: 'menu.fosa-statement',
        // },
      ],
    },
    {
      name: 'loans-center',
      displayName: 'menu.loans-center',
      meta: {
        iconClass: 'fa fa-money',
      },
      disabled: true,
      children: [
        {
          name: 'active-loans',
          displayName: 'menu.active-loans',
        },
        {
          name: 'loan-applications', 
          displayName: 'menu.loan-applications',
        },

        {
          name: 'loan-MyAppliedLoans',
          displayName: 'menu.loan-MyAppliedLoans',
        },
        // {
        //   name: 'loan-GuarantorshipRequests',
        //   displayName: 'menu.loan-GuarantorshipRequests',
        // },
      ],
    },
    {
      name: 'member-activities',
      displayName: 'menu.member-activities',
      meta: {
        iconClass: 'fa fa-tasks',
      },
      disabled: true,
      children: [
        {
          name: 'deposit-funds',
          displayName: 'menu.deposit-funds',
        },
        // {
        //   name: 'funds-transfer',
        //   displayName: 'menu.funds-transfer',
        // },
        // {
        //   name: 'cash-withdrawal',
        //   displayName: 'menu.cash-withdrawal',
        // },
        {
          name: 'loans-payment',
          displayName: 'menu.loans-payment',
        },
        {
          name: 'loan-calculator',
          displayName: 'menu.loan-calculator',
        },
        {
          name: 'mobile-loan',
          displayName: 'menu.mobile-loan',
        },
       /*  {
          name: 'CRM-MemberInquiry',
          displayName: 'menu.CRM-MemberInquiry',
        }
       ,
        {
          name: 'buy-airtime',
          displayName: 'menu.buy-airtime',
        }*/
      ],
    },
    // {
    //   name: 'crm-member',
    //   displayName: 'menu.crm-member',
    //   meta: {
    //     iconClass: 'fa fa-handshake-o',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'crm-MemberInquiry',
    //       displayName: 'menu.crm-MemberInquiry',
    //     },
    //     {
    //       name: 'crm-ListCRMs',
    //       displayName: 'menu.crm-ListCRMs',
    //     },
    //     {
    //       name: 'crm-MyNotifications',
    //       displayName: 'menu.crm-MyNotifications',
    //     },
    //   ],
    // },
    // {
    //   name: 'checkoff',
    //   displayName: 'menu.checkoff',
    //   meta: {
    //     iconClass: 'fa fa-check-square-o',
    //   },
    //   disabled: true,
    //   children: [
      
    //     {
    //       name: 'checkoff-Advice',
    //       displayName: 'checkoff.checkoff-Advice',
    //     },
    //     {
    //       name: 'checkoff-main',
    //       displayName: 'checkoff.checkoff-main',
    //     },
    //   ]
    // },
  ],
}
